// Your company's layer on top of the core apps in specs.ts, like an extension on the base app in Business Central.
// Changes made for one company (through the Implementation Factory) go here, never into specs.ts, so updates to the
// core apps still merge cleanly into the company's own code.
//
//   COMPANY_FIELDS     fields the company adds to an app; they show after the core fields.
//   COMPANY_OVERRIDES  changes to a core field: a new label, required, more options, shown in the list.
//
// The app documentation (Implementation Factory → App documentation) is the master for both: every entry here must
// match an approved change to the documentation, and the pipeline's check fails when they disagree.
import type { Field } from "./specs";

export const COMPANY_FIELDS: Record<string, Field[]> = {};

export const COMPANY_OVERRIDES: Record<string, Record<string, Partial<Omit<Field, "key">> & { inList?: boolean }>> = {};
